import '../styles/index.scss';

import * as d3 from 'd3';
import * as AOS from 'aos';
import 'fslightbox';

const initNavigation = () => {
  const openNavigation = () => {
    if (d3.select('.top-bar').classed('top-bar--static')) {
      const logo = d3.select('[data-navigation-logo]');
      const logoSrc = logo.attr('src');

      logo.attr('src', logo.attr('data-inverted-logo-url'));
      logo.attr('data-inverted-logo-url', logoSrc);
    }

    d3.select('body').style('overflow-y', 'hidden');
    d3.select('[data-navigation-trigger]').classed('navigation-trigger--opened', true);
    d3.select('[data-navigation]').classed('navigation--open', true);
  };

  const closeNavigation = () => {
    if (d3.select('.top-bar').classed('top-bar--static')) {
      const logo = d3.select('[data-navigation-logo]');
      const logoSrc = logo.attr('src');

      logo.attr('src', logo.attr('data-inverted-logo-url'));
      logo.attr('data-inverted-logo-url', logoSrc);
    }

    d3.select('body').style('overflow-y', 'auto');
    d3.select('[data-navigation-trigger]').classed('navigation-trigger--opened', false);
    d3.select('[data-navigation]').classed('navigation--open', false);
  };

  d3.selectAll('[data-navigation-trigger]').on('click', () => {
    const isNavigationOpened = d3.select('[data-navigation]').classed('navigation--open');

    if (isNavigationOpened) {
      closeNavigation();
    } else {
      openNavigation();
    }
  });
};

initNavigation();

AOS.init();

if (process.env.NODE_ENV === 'development') {
  require('../index.html');
}
